import { convertToCron, DEFAULT_SCHEDULER_DATA } from "@SeemplicityDev/shared";
import { AutomationFormBaseFields } from "../../AutomationsUtils";
import { AutomationURLDataReturn } from "../useAutomationURLData/useAutomationURLData";

export const VIEWS_WIZARD_NAME = "Views the Findings List";

export interface ViewsWizardFormFields
  extends AutomationURLDataReturn,
    Pick<AutomationFormBaseFields, "name"> {}

export interface ViewsOutputParams {
  ticket_provider_id: string;
}

export interface ViewsInputParams {
  ticket_provider_id: string;
}

export const buildViewsParams = (
  ticketProviderId: string
): ViewsOutputParams => ({ ticket_provider_id: ticketProviderId });

export const parseViewsInputParams = (
  params: unknown
): ViewsInputParams | null => {
  if (typeof params !== "string") {
    return null;
  }

  try {
    const parsed = JSON.parse(params);

    return typeof parsed?.ticket_provider_id === "string"
      ? { ticket_provider_id: parsed.ticket_provider_id }
      : null;
  } catch {
    return null;
  }
};

export const validateViewsInputParams = (params: unknown): boolean =>
  !!parseViewsInputParams(params);

export const getViewsSchedule = (): string =>
  convertToCron({ schedulerData: DEFAULT_SCHEDULER_DATA });
